import PropTypes from 'prop-types';
import ClearCustomFieldButton from './clear-custom-field-button';
import { BooleanRadio } from '@evertrue/et-components';

const CustomBooleanField = ({ name, value, customField = {}, handleChange = () => {}, handleTouched = () => {} }) => {
  const parsedValue = value === 'true' || value === true ? true : value === 'false' || value === false ? false : null;
  return (
    <div className="interaction-custom-fields-form--input">
      <BooleanRadio
        name={name}
        onChange={(name, bool) => {
          handleTouched(false); // "handleTouched" sets touched to TRUE. the false value tells formik to NOT validate the field after touched.
          handleChange(customField.id, bool);
        }}
        value={parsedValue}
      />
      {value !== null && value !== undefined ? (
        <ClearCustomFieldButton onClick={() => handleChange(customField?.id, null)} />
      ) : null}
    </div>
  );
};

CustomBooleanField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
};

export default CustomBooleanField;
